{
  "1": 744,
  "jan": 744,
  "january": 744,
  "2": 672,
  "feb": 672,
  "february": 672,
  "3": 744,
  "mar": 744,
  "march": 744,
  "4": 720,
  "apr": 720,
  "april": 720,
  "5": 744,
  "may": 744,
  "6": 720,
  "jun": 720,
  "june": 720,
  "7": 744,
  "jul": 744,
  "july": 744,
  "8": 744,
  "aug": 744,
  "august": 744,
  "9": 720,
  "sep": 720,
  "september": 720,
  "10": 744,
  "oct": 744,
  "october": 744,
  "11": 720,
  "nov": 720,
  "november": 720,
  "12": 744,
  "dec": 744,
  "december": 744
}
